import React from "react";
import HMEASTNCBNR from "../assets/Banner/WebBanner/HomeAssistance.png";
import WhyHomeAssistance from "../components/HomeAssistance/WhyHomeAssistance";
import HowItWorks from "../components/HomeAssistance/HowItWorks";
import CoverAppliances from "../components/HomeAssistance/CoverAppliances";
import Header from "../layout/Header";
import banner1 from "../assets/Banner/WebBanner/b2.png";
import CustomerReviews from "../components/AutomobileAssistance/CustomerReviews";
import HeroSection from "../components/HeroSection";
import logo from "../assets/images/About/about-logo.png";
import FAQ from "../components/FAQ";

const HomeAssistance = () => {
  // FAQ data tailored specifically for Home Assistance
  const FAQdata = [
    {
      question: "What is included in the Home Assistance service?",
      answer:
        "Our Home Assistance covers 24/7 help for appliance breakdowns, electrical issues, fire breakout protection, and emergency repairs—all with certified and verified professionals.",
    },
    {
      question: "Can I get assistance for old appliances at home?",
      answer:
        "Yes! We cover appliances up to 10 years old, so you can get support for both new and older items in your home.",
    },
    {
      question: "How do I request a professional for home emergencies or repairs?",
      answer:
        "You can contact us anytime by phone or through our app. Our team will quickly assign a certified technician to resolve your issue at your doorstep.",
    },
    {
      question: "Are your technicians verified and trustworthy?",
      answer:
        "Absolutely. All our professionals undergo strict background checks and are certified experts, ensuring your safety and peace of mind.",
    },
    {
      question: "Is there a plan or subscription required?",
      answer:
        "We offer both customizable subscription plans for ongoing coverage and on-demand services if you prefer flexibility.",
    },
    {
      question: "What types of emergencies are covered under this service?",
      answer:
        "We handle electrical breakdowns, short circuits, sudden appliance failures, and fire or water damage to listed appliances in your home.",
    },
    {
      question: "Do you provide doorstep service?",
      answer:
        "Yes, our experts come directly to your home, delivering repairs, installations, and troubleshooting right where you need them.",
    },
  ];

  return (
    <>
      <HeroSection
        bannerImage={banner1}
        heading="Home Assistance"
        description=" From sudden appliance breakdowns to unexpected home emergencies,
                our Home Assistance is always ready. Get expert help for
                repairs, installations, and troubleshooting—fast and
                hassle-free. We connect you with trusted professionals, so you
                never have to worry about who to call. Enjoy peace of mind
                knowing your home is protected, every single day."
        image={logo}
        gradientBg="linear-gradient(268.53deg, #1363DF 28.18%, #000000 124.21%)"
        gradientOpacity={0.9}
      />

      <div>
        <WhyHomeAssistance />
      </div>
      <div>
        <HowItWorks />
      </div>

      <div>
        <CoverAppliances />
      </div>

      {/* FAQ section for frequently asked questions */}
      <div>
        <FAQ
          FAQdata={FAQdata}
          sectionTitle="Frequently Asked Questions"
          sectionDescription="Find answers to the most common questions below. If you need more help, contact our support."
        />
      </div>


      <CustomerReviews />
    </>
  );
};

export default HomeAssistance;
